import { useTranslation } from "react-i18next";
import englishFlag from "../assets/english.png";
import swedishFlag from "../assets/swedish.png";

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";
  const toggleLanguage = () => {
    i18n.changeLanguage(isEnglish ? "sv" : "en");
  };
  return (
    <button
      type="button"
      onClick={toggleLanguage}
      aria-label={isEnglish ? "Switch to Swedish" : "Switch to English"}
      className="flex w-full items-center gap-3 rounded-md px-2 py-1.5 text-sm text-zinc-600 hover:bg-zinc-100 dark:text-zinc-400 dark:hover:bg-zinc-800 transition-colors cursor-pointer"
    >
      <span>{isEnglish ? <img src={swedishFlag} alt="Swedish" className="h-4" /> : <img src={englishFlag} alt="English" className="h-4" />}</span>
    </button>
  );
};
